<template>
  <div>
    <van-loading type="spinner" v-if="nodata"/>
    <div style="background: #A80034;">
      <div class="logo" v-if="dominItem.templateId === 'temp2'">
        <div style="display: flex; align-items: center; gap: 50px">
        <span style="margin-left: 30px">{{ dominItem.logoName || 'Logo' }}</span>
          <div class="category" >
            <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
                item.label
              }}</span>
          </div>
        </div>
        <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" color="#A80034"></topIcon>
      </div>

      <div class="logo" v-if="dominItem.templateId === 'temp3'">
        <span style="margin-left: 30px">{{ dominItem.logoName || 'Logo' }}</span>
        <div class="category" >
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>
        <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" color="#A80034"></topIcon>
      </div>

      <div class="logo" v-if="dominItem.templateId === 'temp1'">

        <div class="category" style="display: flex">
          <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" color="#A80034"></topIcon>
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>
        <span style="margin-right: 30px">{{ dominItem.logoName || 'Logo' }}</span>
      </div>

    </div>

    <div>
      <div class="news-page">
        <!-- 主要内容区 -->
        <main class="content-wrapper">
          <!-- 左侧边栏 -->
          <aside class="left-sidebar">
            <div class="video-section">
              <h3>{{ $t('con_recommended') }}</h3>
              <div class="video-item" v-for="item in articleList1" @click="toDetail(item.articleShortName)">
                <img :src="item.articleImage">
                <p class="twoHde" style="margin-left: 0">{{ item.articleTitle }}</p>
              </div>
            </div>
          </aside>

          <!-- 中间主内容区 -->
          <section class="main-content">
            <div class="headline-news">
              <img :src="bestItem.articleImage" @click="toDetail(bestItem.articleShortName)">
              <h1 class="twoHde" style="margin-left: 0">{{ bestItem.articleTitle }}</h1>
              <div class="sub-headlines">
                <div class="sub-item" v-for="item in articleList" @click="toDetail(item.articleShortName)">
                  <img :src="item.articleImage">
                  <p class="twoHde" style="margin-left: 0">{{ item.articleTitle }}</p>
                </div>
              </div>
            </div>

          </section>

          <!-- 右侧边栏 -->
          <aside class="right-sidebar">
            <div class="breaking-news">
              <div class="video-section">
                <h3>{{ $t('con_bestnew') }}</h3>
              </div>
              <ul class="news-list">
                <li v-for="item in articleList2" @click="toDetail(item.articleShortName)">
                  <p class="twoHde" style="margin-left: 0">{{ item.articleTitle }}</p>
<!--                  <span class="time">{{ item.uploadTime }}</span>-->
                </li>
              </ul>
            </div>
          </aside>
        </main>
      </div>
      <div class="but-box">
        <div class="news-container">
          <div class="news-content">
            <!-- 中国新闻 -->
            <div class="news-section">
              <div class="video-section">
                <h3>{{ $t('con_hot_con') }}</h3>
              </div>
              <!-- 中国新闻大图 -->
              <div class="news-big-card" v-for="item in articleList3.slice(0,1)" @click="toDetail(item.articleShortName)">
                <img
                    :src="item.articleImage"
                    class="news-image"
                />
                <div class="news-overlay">
                  <h3 class="news-title">{{ item.articleTitle }}</h3>
<!--                  <div class="news-meta">-->
<!--                    <span class="news-time">{{ item.uploadTime }}</span>-->
<!--                  </div>-->
                </div>
              </div>

              <!-- 中国新闻列表 -->
              <div class="news-list">
                <div class="news-item" v-for="item in articleList3.slice(1,11)" @click="toDetail(item.articleShortName)">
                  <div class="news-item-content">
                    <h3 class="twoHde" style="margin-left: 0">{{ item.articleTitle }}</h3>
<!--                    <div class="news-item-meta">{{ item.uploadTime }}</div>-->
                  </div>
                  <img
                      :src="item.articleImage"
                      class="news-item-image"
                  />
                </div>
              </div>
            </div>

            <!-- 国际新闻 -->
            <div class="news-section">
              <div class="video-section">
                <h3>{{ $t('con_latest') }}</h3>
              </div>

              <!-- 国际新闻大图 -->
              <div class="news-big-card" v-for="item in articleList4.slice(0,1)" @click="toDetail(item.articleShortName)">
                <img
                    :src="item.articleImage"
                class="news-image"
                />
                <div class="news-overlay">
                  <h3 class="news-title">{{ item.articleTitle }}</h3>
<!--                  <div class="news-meta">-->
<!--                    <span class="news-time">{{ item.uploadTime }}</span>-->
<!--                  </div>-->
                </div>
              </div>

              <!-- 中国新闻列表 -->
              <div class="news-list">
                <div class="news-item" v-for="item in articleList4.slice(1,11)" @click="toDetail(item.articleShortName)">
                  <div class="news-item-content">
                    <h3 class="twoHde" style="margin-left: 0">{{ item.articleTitle }}</h3>
<!--                    <div class="news-item-meta">{{ item.uploadTime }}</div>-->
                  </div>
                  <img
                      :src="item.articleImage"
                  class="news-item-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="buttom">
      <div class="kuai">
      <div class="btn-logo">{{ dominItem.logoName || 'Logo' }}
        <div style="display: flex; align-items: center">
        <img class="imgsss" v-if="dominItem.nationId !== 'cn'" v-for="item in iconListsmall" @click="openLink(item.link)" :src="item.url" alt="">
        </div>
      </div>
      <div class="explore">
        <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer; color: #ffffff">{{ item.label }}</span>
      </div>
      <footers is00="is04" color="#ffffff" widd="none" style="border-top: 1px solid #fff"
               :articleListlast="articleListlast" :current="current"></footers>
      </div>
    </div>
  </div>
</template>

<script>
import {getOne, newContent} from "@/api"
import topIcon from '../../icons/small.vue'
import {format} from "date-fns";
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"

export default {
  components: {topIcon, buttomIcon, footers},


  props: {
    dominItem: Object
  },

  name: "index",
  data() {
    return {
      bestItem: {},
      nodata: false,
      // template: 'temp3',
      current: 1,
      recommendList: [],
      latestNewsList: [],
      articleList: [],
      articleList1: [],
      articleList2: [],
      articleList3: [],
      articleList4: [],
      articleListlast: [],
      recommendList1: [],
      typeList: [
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_home'), id: 1},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_LIFESTYLE'), id: 5},
      ],
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  created() {
    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId


    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    } else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
  },

  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },


    // 获取推荐文章列表
    getArticleList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 12,
        articleNationId: this.nationId,
        articleType: 'con_recommended'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows
        this.nodata = false
      })
    },


    // 获取最新文章
    getLatestNewsList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 6,
        articleNationId: this.nationId,
        articleType: 'con_latest'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取热门文章
    getRecommendList() {
      newContent({
        articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 12,

        articleNationId: this.nationId, articleType: 'con_hot_con'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList2 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList1() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 12,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList3 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList2() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 12,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList4 = res.rows
      })
    },

    // 获取最下面文章列表  相关文章
    getArticleListlast() {
      // this.nodata = true
      newContent({
        articleCategoryId: this.current,
        pageNum: 3,
        pageSize: 6,
        articleNationId: this.nationId,
        articleType: 'con_related'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
/* 左侧边栏样式 */
.video-section h3,
.hot-news h3 {
  font-size: 18px;
  border-left: 4px solid #c91f37;
  padding-left: 10px;
  margin-bottom: 15px;
}
.news-page {
  max-width: 1500px;
  margin: auto;
  /* 基础样式 */
  .news-container {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
  }

  /* 头部样式 */
  .main-header {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-bottom: 2px solid #c91f37;
  }

  .logo {
    font-size: 28px;
    font-weight: bold;
    color: #c91f37;
    margin-right: 40px;
  }

  .main-nav ul {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .main-nav li {
    margin-right: 25px;
  }

  .main-nav a {
    text-decoration: none;
    color: #333;
    font-weight: 500;
    font-size: 16px;
  }

  .main-nav a.active {
    color: #c91f37;
  }

  /* 内容区布局 */
  .content-wrapper {
    display: flex;
    margin-top: 20px;
    gap: 20px;
  }

  .left-sidebar {
    width: 220px;
  }

  .main-content {
    flex: 1;
  }

  .right-sidebar {
    width: 300px;
  }

  /* 左侧边栏样式 */
  .video-section h3,
  .hot-news h3 {
    font-size: 18px;
    border-left: 4px solid #c91f37;
    padding-left: 10px;
    margin-bottom: 15px;
  }

  .video-item {
    position: relative;
    margin-bottom: 20px;
    border-bottom: 1px solid #EAEAEA;
    padding-bottom: 10px;
  }

  .video-item img {
    width: 100%;
    height: 120px;
    object-fit: cover;
  }

  .video-item p {
    margin: 8px 0 0;
    font-size: 14px;
    line-height: 1.4;
  }

  .play-icon {
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 40px;
    background-color: rgba(0,0,0,0.5);
    border-radius: 50%;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }

  .hot-news ol {
    padding-left: 20px;
  }

  .hot-news li {
    margin-bottom: 12px;
    line-height: 1.4;
  }

  .hot-news a {
    color: #333;
    text-decoration: none;
    font-size: 14px;
  }

  /* 主内容区样式 */
  .headline-news img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }

  .headline-news h1 {
    font-size: 24px;
    margin: 15px 0;
    color: #333;
  }

  .sub-headlines {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }

  .sub-item {
    flex: 1;
    min-width: 200px;
  }

  .sub-item img {
    width: 100%;
    height: 160px;
    object-fit: cover;
  }

  .sub-item p {
    font-size: 14px;
    margin: 8px 0 0;
  }

  .international-news h2 {
    font-size: 20px;
    margin: 30px 0 15px;
    border-bottom: 2px solid #f0f0f0;
    padding-bottom: 10px;
  }

  .news-row {
    display: flex;
    gap: 20px;
  }

  .news-card {
    flex: 1;
  }

  .news-card h3 {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .news-card p {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
  }

  /* 右侧边栏样式 */
  .breaking-news h3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    margin-bottom: 15px;
  }

  .red-dot {
    color: #c91f37;
    font-size: 20px;
  }

  .more {
    color: #999;
  }

  .news-tabs {
    display: flex;
    margin-bottom: 15px;
    border-bottom: 1px solid #f0f0f0;
  }

  .news-tabs button {
    background: none;
    border: none;
    padding: 8px 15px;
    cursor: pointer;
    font-size: 14px;
    color: #666;
  }

  .news-tabs button.active {
    color: #c91f37;
    border-bottom: 2px solid #c91f37;
  }

  .news-list {
    list-style: none;
    padding: 0;
  }

  .news-list li {
    padding: 12px 0;
    border-bottom: 1px dashed #f0f0f0;
    font-size: 14px;
    display: flex;
    flex-direction: column;
  }

  .category {
    display: inline-block;
    background-color: #f0f0f0;
    padding: 2px 8px;
    font-size: 12px;
    border-radius: 3px;
    margin-right: 5px;
  }

  .video-tag {
    color: #c91f37;
  }

  .time {
    color: #999;
    font-size: 12px;
    margin-top: 5px;
  }

  /* 响应式调整 */
  @media (max-width: 1200px) {
    .content-wrapper {
      flex-direction: column;
    }
    .left-sidebar, .main-content, .right-sidebar {
      width: 100%;
    }
    .news-tabs {
      overflow-x: auto;
    }
  }
}

.but-box {
  width: 1500px;
  margin: auto;
  .news-container {
    background-color: #fff;
    min-height: 100vh;
  }

  .news-header {
    margin-bottom: 20px;
    h1 {
      font-size: 24px;
      color: #333;
      font-weight: bold;
    }
  }

  .news-tabs {
    margin-bottom: 20px;
    .tabs-container {
      display: flex;
      border-bottom: 2px solid #f0f0f0;
      .tab-item {
        padding: 10px 20px;
        cursor: pointer;
        color: #666;
        &.active {
          color: #ff4d4f;
          border-bottom: 2px solid #ff4d4f;
          font-weight: bold;
        }
        &:hover {
          color: #ff4d4f;
        }
      }
    }
  }

  .news-content {
    display: flex;
    gap: 20px;
  }

  .news-section {
    flex: 1;
    .section-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      h2 {
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }
      .more-link {
        color: #999;
        text-decoration: none;
        &:hover {
          color: #ff4d4f;
        }
      }
    }
  }

  .news-big-card {
    position: relative;
    margin-bottom: 16px;
    overflow: hidden;
    border-radius: 4px;
    .news-image {
      width: 100%;
      height: 300px;
      object-fit: cover;
      transition: transform 0.3s ease;
    }
    .news-overlay {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 16px;
      background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
      color: #fff;
      .news-title {
        font-size: 16px;
        margin: 0 0 8px 0;
        font-weight: bold;
      }
      .news-meta {
        display: flex;
        gap: 10px;
        font-size: 12px;
      }
    }
    &:hover .news-image {
      transform: scale(1.05);
    }
  }

  .news-list {
    .news-item {
      display: flex;
      margin-bottom: 12px;
      padding: 12px;
      background-color: #fafafa;
      border-radius: 4px;
      transition: background-color 0.3s ease;
      &:hover {
        background-color: #f0f0f0;
      }
      .news-item-content {
        flex: 1;
        margin-right: 12px;
        h4 {
          font-size: 14px;
          color: #333;
          margin: 0 0 4px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .news-item-meta {
          font-size: 12px;
          color: #999;
        }
      }
      .news-item-image {
        width: 80px;
        height: 60px;
        object-fit: cover;
        border-radius: 4px;
      }
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    .news-content {
      flex-direction: column;
    }
    .news-tabs {
      overflow-x: auto;
      .tabs-container {
        min-width: 600px;
      }
    }
  }
}


.logo {
  width: 1500px;
  margin: 0 auto;
  padding: 10px 0;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  font-size: 20px;
  color: #ffffff;

  justify-content: space-between;
  font-weight: bold;
  text-align: left;
}

.logo-temp1 {
  padding: 0 20px 0 10%;
}

.logo-temp2 {
}

.category {
  min-height: 40px;
  //margin-bottom: 30px;
  color: #ffffff;
  font-weight: 700;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid #E6E8EA;
  line-height: 38px;

  span {
    font-weight: 500;
    font-size: 17px;
    display: inline-block;
    padding: 0 10px;
    cursor: pointer;
    position: relative;
    //border-bottom: 3px solid #ffffff;
  }

  span:hover {
    color: #8A898A;
    //border-bottom: 3px solid #013497;
    transition: all .1s ease;
    background: #F9F9F9;
    border-radius: 5px;
    //border-bottom: 3px solid #E2001A;
  }

  .choose {
    transition: all .1s ease;
    color: #A80034;
    border-radius: 5px;
    background: #F9F9F9;
    //border-bottom: 3px solid #013497;
  }
}

.buttom {
  background: #000000;
  display: flex;
  padding-top: 30px;
  flex-direction: column;

  .kuai {
    //width: 1260px;
    padding: 0 calc(10% - 20px) 0 calc(10% - 40px);
    margin: auto;
  }

  .btn-logo {
    margin-left: 50px;
    font-size: 40px;
    color: #ffffff;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: transparent;
  }
  .explore {
    display: flex;
    margin-left: 50px;
    margin-top: 30px;
    margin-bottom: 20px;
    align-items: center;
    font-weight: bold;
    span {
      margin-right: 10px;
      font-size: 15px;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #000000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  display: flex;
  flex-wrap: wrap;

  span {
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.imgsss {
  width: 30px;
  height: 30px;
}

.imgsss:nth-child(4) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(5) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(3) {
  width: 40px;
  height: 40px;
}

.article-image1 {
  width: 80px;
  height: 80px;
  object-fit: cover;
}
.bgSpan {
  color: #ffffff;
  border-radius: 5px;
  border: 1px solid red;
  display: inline-block;
  padding: 5px 10px;
  background: #E2001A;
}

</style>